import { PropTypes } from "prop-types";
import React, { Fragment } from "react";

export const precachePhoto = (photo) => {
  if (!photo || !photo.watermarkedImg) {
    console.error("Attempted to precache undefined photo or watermarkedImg");
    return Promise.resolve(null);
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = photo.watermarkedImg;
    }, 200);
  });
};

const PrecacheImg = props => {
  const precache = images => {
    let image;
    for (let i = 0, len = images.length; i < len; i += 1) {
      image = new Image(); // eslint-disable-line no-undef
      image.src = images[i];
    }
    return false;
  };

  return <Fragment>{precache(props.images)}</Fragment>;
};

PrecacheImg.propTypes = {
  images: PropTypes.array.isRequired
};

export default PrecacheImg;
